import { render, staticRenderFns } from "./TrainerSearchTeam.vue?vue&type=template&id=20e9d78e&scoped=true"
import script from "./TrainerSearchTeam.vue?vue&type=script&lang=js"
export * from "./TrainerSearchTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e9d78e",
  null
  
)

export default component.exports